import { useMutation } from "@tanstack/react-query";
import { DeleteEventsParams, deleteEvents } from "supabase/events";
import { queryClient } from "utils";

export const useDeleteEvents = (onSuccess: () => any) => {
  const mutation = useMutation({
    mutationFn: ({ uids }: DeleteEventsParams) => {
      return deleteEvents({ uids });
    },

    onMutate: (variables) => {
      queryClient.setQueriesData({ queryKey: ["events"] }, (data: any) => {
        if (data && data.events) {
          return {
            ...(data as object),
            events: data.events.filter(
              (event: any) => !variables.uids.includes(event.uid)
            ),
          };
        } else {
          return data;
        }
      });
    },
  });

  return mutation;
};
